import { modals } from "@mantine/modals";
import { repositoryPos } from "../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { MessageResponse } from "../../../model/MessageResponse";
import { Box, Button, Flex, Text } from "@mantine/core";
import { IconX } from "@tabler/icons-react";

const DeleteSerialStatus = ({
  listId,
  onSuccess,
}: {
  listId: number[];
  onSuccess: any;
}) => {
  const handleDeleteSerialStatus = async () => {
    const res = await repositoryPos.post<MessageResponse<any>>(
      "/api/v1/TblSerialStatus/delete",
      listId
    );

    if (res && res.success) {
      NotificationExtension.Success("Xóa trạng thái serial thành công !");
      setTimeout(() => {
        modals.closeAll();
        onSuccess(true);
      }, 1000);
    }
  };

  return (
    <Box maw={400} w={"27.5vw"}>
      <Flex align={"center"} direction={"column"} gap={"xs"} mt={10}>
        <Text size="18px" fw={500}>
          Bạn có chắc muốn xóa các trạng thái serial này ?
        </Text>
        <Button
          leftSection={<IconX size={16} />}
          color="red"
          onClick={() => handleDeleteSerialStatus()}
        >
          Xác nhận
        </Button>
      </Flex>
    </Box>
  );
};

export default DeleteSerialStatus;
